import { Container } from './styles'

export function EmployeeRoot({ children, size = 'middle' }) {
  return <Container size={size}>{children}</Container>
}
